// ========================== custom product map ========================== 

$(".customize_map_wrapper a[href='#open_form']").click(function(e) {
    e.preventDefault();
    $("body").addClass("cc-popup-no-scroll");
    $(".form_popup").addClass("active");
});
$(document).mouseup(function (e) {
    var popup = $(".form_popup form");
    if (!popup.is(e.target) && popup.has(e.target).length === 0) {
        $("body").removeClass("cc-popup-no-scroll");
        $(".form_popup").removeClass("active");
    }
});
$(".close_btn_form").click(function (e) {
    $("body").removeClass("cc-popup-no-scroll");
    $(".form_popup").removeClass("active");
});

  // mapboxgl.accessToken = 'pk.eyJ1Ijoid2lqY2twcmludHMiLCJhIjoiY2tlY3Y0MnV1MG1oYzMwcDc5ZjNyZ242NyJ9.IG8tDQMmJHnL28AvpTCHAw';   // other api
  mapboxgl.accessToken = 'pk.eyJ1IjoiaXp5Ym90dGxlcyIsImEiOiJjbHBweGxjejUxNTJ0MnBxbnE0dXJyeW9mIn0.9wC15_6ijgdQ2BqqSLYXMw';
  const map = new mapboxgl.Map({
  	container: 'map', // container ID
  	style: 'mapbox://styles/izybottles/clqgeatd200im01qr32swb2vn',
  	center: [4.9,52.378],
  	zoom: 10,
    preserveDrawingBuffer: true
  });
  const geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    mapboxgl: mapboxgl,
    flyTo: {
      bearing: 0,
      speed: 50,
      curve: 50,
      zoom: 10,
      easing: function (t) {
        return t;
      }
    }
  });

  setTimeout(() => {
    map.resize();
  },500)

  map.addControl(new mapboxgl.NavigationControl());
  const geolocate = new mapboxgl.GeolocateControl({
    positionOptions: {
      enableHighAccuracy: true
    },
    trackUserLocation: true
  });
  map.addControl(geolocate);

  geocoder.on('result', e => {
      var lanLat_one = e.result.center[1].toFixed(2) + '°N';
      var lanLat_Two = e.result.center[0].toFixed(2) + '°E';
      $(".input_custom_field[data-field='input_field_1']").val(lanLat_one + " " + lanLat_Two);
      $(".small_text").text(lanLat_one + " " + lanLat_Two);
      $(".input_custom_field[data-field='input_field_2']").val(e.result.text);
      $(".big_text").text(e.result.text);
      $(".input_custom_field[data-field='input_field_3']").val(e.result.place_name.split(",").pop());
      $(".italic_text").text(e.result.place_name.split(",").pop());
      map.resize();
      mapcanvas.renderAll();
  });
  document.getElementById('geocoder').appendChild(geocoder.onAdd(map));





// ========================== custom events ==========================

  $(".customize_map_wrapper .input_custom_field").keyup(function() {
    var getRelatedDiv = $(this).data("rel");
    $("."+getRelatedDiv).html($(this).val());

    id = $(this).attr('id');
    newtext = $(this).val();
    input = $(this);
    
    objs = mapcanvas.getObjects();
    objs.forEach(function(obj,value) {
      if (obj && obj.id == id) {
        setTimeout(function(){
          obj.setText(newtext);
          mapcanvas.renderAll();
          input.attr("data-text", newtext);
          
        },200);
      }
    });
    mapcanvas.renderAll();
  });

  $(".customize_map_wrapper .geocoder .buttons_wrapper .livelocation_tracker").click(function() {
    $("[aria-label='Find my location']").trigger('click');
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };
    function success(pos) {
      const crd = pos.coords;
        async function logMapData() {
          const response = await fetch(`https://api.tiles.mapbox.com/v4/geocode/mapbox.places/${crd.longitude},${crd.latitude}.json?access_token=pk.eyJ1Ijoid2lqY2twcmludHMiLCJhIjoiY2tlY3Y0MnV1MG1oYzMwcDc5ZjNyZ242NyJ9.IG8tDQMmJHnL28AvpTCHAw`);
          const mapData = await response.json();
          var livelanLat_one = mapData.query[1].toFixed(2) + '°N';
          var livelanLat_Two = mapData.query[0].toFixed(2) + '°E';
          $(".input_custom_field[data-field='input_field_1']").val(livelanLat_one + " " + livelanLat_Two);
          $(".small_text").text(livelanLat_one + " " + livelanLat_Two);
          $(".input_custom_field[data-field='input_field_2']").val(mapData.features[3].place_name.split(",")[0]);
          $(".big_text").text(mapData.features[3].place_name.split(",")[0]);
          $(".input_custom_field[data-field='input_field_3']").val(mapData.features[3].place_name.split(",").pop());
          $(".italic_text").text(mapData.features[3].place_name.split(",").pop());
          city_text.top = lang_lat_text.top + lang_lat_text.height + 5;
          country_text.top = city_text.top + city_text.height + 5;
          mapcanvas.renderAll();
        }
      logMapData();
    }
    function error(err) {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    }
    
    navigator.geolocation.getCurrentPosition(success, error, options);
  });

  $(".customize_map_wrapper .leftside_main_step_container .custom-map-collection-tab-content-product-image").click(function(e) {
      e.preventDefault();
      $(".customize_map_wrapper .leftside_main_step_container .custom-map-collection-tab-content-product-image").removeClass("selected_product");
      $(this).addClass("selected_product");
      var getVariantId = $(this).attr("data-id");
      var getVariantPrice = $(this).attr("data-price");
      $('.customize_map_wrapper .step-item-wrapper button.product_buy_btn').attr("data-variant-id" , getVariantId);
      $('.customize_map_wrapper .step-item-wrapper .product_price').html(theme.Shopify.formatMoney(getVariantPrice, theme.money_format));
          var getImageLink = $(this).attr('data-set-defaultimage');
          var getImageoverlayLink = $(this).attr('data-set-overlayImage');
    var getActiveProduct = $(".customize_map_wrapper .leftside_main_step_container .collection-map-tab.is-active").data("tab");
          setProductImage(getImageLink,getImageoverlayLink,getActiveProduct);
      $(".customize_map_wrapper .main_contains_wrapper").css("--custom-background-color", $(this).data('bg-color'));
      var TextColor = $(this).data('text-color');
      lang_lat_text.fill = TextColor;
      city_text.fill = TextColor;
      country_text.fill = TextColor;

     if (getActiveProduct == "mug") {
        $('.customize_map_wrapper').addClass('mug_map');
        $('.customize_map_wrapper').removeClass('bottle_map');

        var getCanvasHeight = $('.main_contains_wrapper').height();
        var getMapCanvasHeight = $('.main_contains_wrapper .map_wrapper').height();
        var canvasMinusHeight = getCanvasHeight - (getMapCanvasHeight + 100);
        var canvasSetHeight = getCanvasHeight - canvasMinusHeight;
        $('.main_contains_wrapper').css({
            "margin-top": "-" + canvasMinusHeight + "px"
        });
       
        slot1.left = mapcanvas.width / 2.25;
        slot1.top = mapcanvas.height / 2.5;
        slot1.width = mapcanvas.width / 2.2; 
        slot1.height = mapcanvas.height / 1.5;

        let allFontleft = mapcanvas.width / 2;
        lang_lat_text.left = allFontleft;
        lang_lat_text.top = mapcanvas.height / 1.24;
        city_text.left = allFontleft;       
        city_text.top = lang_lat_text.top + lang_lat_text.height + 5;
        country_text.left = allFontleft;    
        country_text.top = city_text.top + city_text.height + 5;
       
     }else if(getActiveProduct == "bottle"){
        $('.customize_map_wrapper').removeClass('mug_map');
        $('.customize_map_wrapper').addClass('bottle_map');     

        $('.main_contains_wrapper').css({
          "margin-top": 0 + "px"
        });

        slot1.left = mapcanvas.width / 2.5;
        slot1.top = mapcanvas.height / 3.5;
        slot1.width = mapcanvas.width / 2.75; 
        slot1.height = mapcanvas.height / 1.5;

        let allFontleft = mapcanvas.width / 2.4;
        lang_lat_text.left = allFontleft;
        lang_lat_text.top = mapcanvas.height / 1.28;
        city_text.left = allFontleft;       
        city_text.top = lang_lat_text.top + lang_lat_text.height + 5;
        country_text.left = allFontleft;       
        country_text.top = city_text.top + city_text.height + 5; 
     }


    
      loadMaponBottle();
  })

  $(".customize_map_wrapper .leftside_main_step_container .collection-map-tab").click(function() {
    $(".customize_map_wrapper .leftside_main_step_container .collection-map-tab").removeClass("is-active");
    $(this).addClass("is-active");
    var getSlectorDiv = $(this).data("tab");
    $(".custom-map-collection-tab-content-wrapper .custom-map-collection-tab-content").removeClass("is-active");
    $("#"+getSlectorDiv).addClass("is-active");
    $(".custom-label-type").text($(this).data('label'));

    var getImageLink = $(this).attr('data-set-defaultimage');
    var getImageoverlayLink = $(this).attr('data-set-overlayImage');
    setProductImage(getImageLink,getImageoverlayLink,getSlectorDiv);
    loadMaponBottle();

    var getColorType = $('.custom-map-collection-tab-content-product .custom-map-collection-tab-content-product-image.selected_product').attr('data-index');
    $('.custom-map-collection-tab-content.is-active .custom-map-collection-tab-content-product-image').each(function(){
      var allIndex = $(this).attr('data-index');
      if(getColorType == allIndex){
        $(this).trigger('click');
        $(this).addClass('selected_product')
      }else{
        $(this).removeClass('selected_product')
      }
    });

     if (getSlectorDiv == "mug") {
        $('.customize_map_wrapper').addClass('mug_map');
        $('.customize_map_wrapper').removeClass('bottle_map');

        var getCanvasHeight = $('.main_contains_wrapper').height();
        var getMapCanvasHeight = $('.main_contains_wrapper .map_wrapper').height();
        var canvasMinusHeight = getCanvasHeight - (getMapCanvasHeight + 100);
        var canvasSetHeight = getCanvasHeight - canvasMinusHeight;
        $('.main_contains_wrapper').css({
            "margin-top": "-" + canvasMinusHeight + "px"
        });
       
        slot1.left = mapcanvas.width / 2.25;
        slot1.top = mapcanvas.height / 2.52;
        slot1.width = mapcanvas.width / 2.2; 
        slot1.height = mapcanvas.height / 1.5;

        let allFontleft = mapcanvas.width / 2;
        lang_lat_text.left = allFontleft;
        lang_lat_text.top = mapcanvas.height / 1.24;
        city_text.left = allFontleft;       
        city_text.top = lang_lat_text.top + lang_lat_text.height + 5;
        country_text.left = allFontleft;    
        country_text.top = city_text.top + city_text.height + 5;
       
     }else if(getSlectorDiv == "bottle"){
        $('.customize_map_wrapper').removeClass('mug_map');
        $('.customize_map_wrapper').addClass('bottle_map');     

        $('.main_contains_wrapper').css({
          "margin-top": 0 + "px"
        });

        slot1.left = mapcanvas.width / 2.5;
        slot1.top = mapcanvas.height / 3.5;
        slot1.width = mapcanvas.width / 2.75; 
        slot1.height = mapcanvas.height / 1.5;

        let allFontleft = mapcanvas.width / 2.4;
        lang_lat_text.left = allFontleft;
        lang_lat_text.top = mapcanvas.height / 1.28;
        city_text.left = allFontleft;       
        city_text.top = lang_lat_text.top + lang_lat_text.height + 5;
        country_text.left = allFontleft;       
        country_text.top = city_text.top + city_text.height + 5; 
     }
    
  })

  $(".map_qty_btn[data-type='decrease']").click(function() {
    var currentQuantity = parseInt($(this).parents().find(".qty_input").val(), 10);
    if (currentQuantity > 30) {
      $(this).parents().find(".qty_input").val(currentQuantity - 1);
    }
  });
    
  $(".map_qty_btn[data-type='increase']").click(function() {
    var currentQuantity = parseInt($(this).parents().find(".qty_input").val(), 10);
    $(this).parents().find(".qty_input").val(currentQuantity + 1);
  });




// ========================== Product preview ==========================

  var mapcanvas = this.__canvas = new fabric.Canvas('map_product_canvas');
  var mapctx = mapcanvas.getContext('2d');

  function mapCanvasResize() { 
     mapcanvas.setWidth($(".customize_map_wrapper .product_image_preview_wrapper .rimage-outer-wrapper").width());
     mapcanvas.setHeight($(".customize_map_wrapper .product_image_preview_wrapper .rimage-outer-wrapper").height());      
  }

    mapCanvasResize();

  function setProductImage(image,overlayImage,type) {
    mapcanvas.clear();
    window.fabric.Image.fromURL(image, function(img) {
      let scaleRatio;
      if (type !== undefined) {
        if (type === 'mug') {
          scaleRatio = Math.min( mapcanvas.height / (img.height + img.width / 1.8), mapcanvas.height / (img.height + img.width / 2));
        } else {
          scaleRatio = Math.min(mapcanvas.width / img.width, mapcanvas.height / img.height);
        }
      } else {
        scaleRatio = Math.min(mapcanvas.width / img.width, mapcanvas.height / img.height);
      }
      // console.log(type,mapcanvas.width,'--',img.width,mapcanvas.height,'===',img.height, scaleRatio,'scaleRatio 1');

      if (type === 'mug') {
        mapcanvas.setBackgroundImage(img, mapcanvas.renderAll.bind(mapcanvas), {
          left: mapcanvas.width / 2,
          top: mapcanvas.height / 1.49,
          originX:"center",
          originY:"center",
          scaleX: scaleRatio,
          scaleY: scaleRatio,
        });
      }else{
        mapcanvas.setBackgroundImage(img, mapcanvas.renderAll.bind(mapcanvas), {
          left: mapcanvas.width / 2,
          top: mapcanvas.height / 2,
          originX:"center",
          originY:"center",
          scaleX: scaleRatio,
          scaleY: scaleRatio,
        });
      }
      
    });
    $(".customize_map_wrapper .product_image_preview_wrapper .rimage-outer-wrapper").addClass("added_canvas");
    $(".customize_map_wrapper .product_image_preview_wrapper .canvas-container").addClass("added_canvas");
    fabric.Image.fromURL(overlayImage, function(img) {
        let scaleRatio;
        if (type !== undefined) {
          if (type === 'mug') {
            scaleRatio = Math.min( mapcanvas.height / (img.height + img.width / 1.8), mapcanvas.height / (img.height + img.width / 2));
          } else {
            scaleRatio = Math.min(mapcanvas.width / img.width, mapcanvas.height / img.height);
          }
        } else {
          scaleRatio = Math.min(mapcanvas.width / img.width, mapcanvas.height / img.height);
        }

        if (type === 'mug') {
          img.set({
              scaleX: scaleRatio,
              scaleY: scaleRatio,
              left: mapcanvas.width / 2,
              top: mapcanvas.height / 1.49,
              objectCaching: false,
              originX: 'center',
              originY: 'center'
           });          
        }else{
          img.set({
              scaleX: scaleRatio,
              scaleY: scaleRatio,
              left: mapcanvas.width / 2,
              top: mapcanvas.height / 2,
              objectCaching: false,
              originX: 'center',
              originY: 'center'
           });
        }
         mapcanvas.setOverlayImage(img, mapcanvas.renderAll.bind(mapcanvas));
     });
    mapcanvas.renderAll();
  }

    var defaultImage = $(".customize_map_wrapper .leftside_main_step_container .collection-map-tab.is-active").data("set-defaultimage");
    var overlaydefaultImage = $(".customize_map_wrapper .leftside_main_step_container .collection-map-tab.is-active").data("set-overlayimage");
    setProductImage(defaultImage,overlaydefaultImage,"");
  
  

// ========================== Save map Preview ========================== 
  const alignCenter = true;
  var slot1 = new fabric.Rect({
    originX: 'left', 
    originY: 'top',
    left: mapcanvas.width / 2.5, 
    top: mapcanvas.height / 3.5,
    width: mapcanvas.width / 2.75, 
    height: mapcanvas.height / 1.5,
    fill: 'transparent',
    stroke: 'white',
    strokeWidth: 0,
    selectable: false
  });

  var currentimage;
  function loadMaponBottle() {
    setTimeout(() => {
      const mapdataURL = document.querySelector('.mapboxgl-canvas').toDataURL();

      if (currentimage) {
          mapcanvas.remove(currentimage);
        }
      
      fabric.Image.fromURL(mapdataURL, function(img) {
        currentimage = img;
       var oImg = img.set({
        id: 'test',
        left: mapcanvas.width / 4,
        top:  mapcanvas.height / 2,
        cornerSize: 0,
        hasBorders: false,
        opacity: 1,
        globalCompositeOperation: 'multiply',
         clipTo: function(ctx) {
          return clipBySlot(ctx, img, slot1);	 
         }
      },{
        crossOrigin: 'anonymous'
      });
        
      oImg.scaleToWidth(mapcanvas.width / 1.9);
      oImg.scaleToHeight(mapcanvas.height / 1.55); 
      
      scaleImageToSlot(img, slot1);
      mapcanvas.add(oImg).renderAll();
      mapcanvas.sendToBack(oImg);
      var objle = mapcanvas.getObjects();
      mapcanvas.setActiveObject(mapcanvas.item(objle.length - 1));
    });

      mapcanvas.remove(lang_lat_text);
      mapcanvas.remove(city_text);
      mapcanvas.remove(country_text);
      mapcanvas.add(lang_lat_text);
      mapcanvas.add(city_text);
      mapcanvas.add(country_text);
      lang_lat_text.text = $(".input_custom_field[data-field='input_field_1']").val();
      city_text.text = $(".input_custom_field[data-field='input_field_2']").val();
      country_text.text = $(".input_custom_field[data-field='input_field_3']").val();
      setTimeout(() => {
        city_text.top = lang_lat_text.top + lang_lat_text.height + 5;
        country_text.top = city_text.top + city_text.height + 5;
        mapcanvas.renderAll();
      },500)
    },1000)
  }


  function scaleImageToSlot(image, slot) {
    let ratio = Math.min(slot.width / image.width, slot.height / image.height);
  
    if (ratio <= 1) {
      image.scaleToWidth(slot.width);
      let newHeight = image.height * image.scaleY;
  
      if (newHeight < slot.height) {
        image.scaleToHeight(slot.height);
      }
    } else {
      image.scaleToHeight(slot.height);
      let newWidth = image.width * image.scaleX;
  
      if (newWidth < slot.width) {
        image.scaleToWidth(slot.width);
      }
    }
  
    var shiftLeft = (slot.width - image.width * image.scaleX) / 2;
    var shiftTop = (slot.height - image.height * image.scaleY) / 2;
  
    if (alignCenter) {
      image.setLeft(slot.left + shiftLeft);

     var getActiveProduct = $(".customize_map_wrapper .leftside_main_step_container .collection-map-tab.is-active").data("tab")
     if (getActiveProduct == "mug") {
      image.setTop(slot.top / 1.3 + shiftTop);       
     }else if(getActiveProduct == "bottle"){
      image.setTop(slot.top + shiftTop);      
     }
    } else {
      if (image.left < slot.left) {
        image.setLeft(slot.left);
      }
      if (image.top < slot.top) {
        image.setTop(slot.top);
      }
    }
  }
  
  function clipBySlot(ctx, image, slot) {
    var scaleXTo1 = 1 / image.scaleX;
    var scaleYTo1 = 1 / image.scaleY;
  
    ctx.save();
  
    ctx.translate(0, 0);
    ctx.rotate(degToRad(image.angle * -1));
    ctx.scale(scaleXTo1, scaleYTo1);
  
    ctx.beginPath();
  
    const boundingRect = image.getBoundingRect();
  
    ctx.rect(
      slot.left - image.left - Math.floor(boundingRect.width / 2),
      slot.top - image.top  - Math.floor(boundingRect.height / 2),
      slot.width,
      slot.height
    );
    ctx.closePath();
  
    ctx.restore();
  }
  function degToRad(degrees) {
    return degrees * (Math.PI / 180);
  }


  map.on('load', loadMaponBottle);
  map.on('moveend', loadMaponBottle);


  $(".customize_map_wrapper .step-item-wrapper .map_style_wrappers li.map_style_btn").click(function() {
    var mapStyle = $(this).attr("data-map-style");
    map.setStyle(mapStyle);
    $(".customize_map_wrapper .step-item-wrapper .map_style_wrappers li.map_style_btn").removeClass("active");
    $(this).addClass("active");
      loadMaponBottle();
  });


var backgroundColor = '#000000';

  let lang_lat_textvwFontSize = mapcanvas.width * 0.016;
  let allFontWidthVh = mapcanvas.width * 0.350;
  let allFontleft = mapcanvas.width / 2.4;
  var lang_lat_text = new fabric.Textbox("Text", {
    id: "langLat",
    selectable: false,
    fill: backgroundColor,
    fontStyle: 'normal',
    fontWeight: 300,
    width: allFontWidthVh,
    text: '',
    textAlign: 'center',
    fontFamily: "Montserrat,sans-serif",
    top: mapcanvas.height / 1.28,
    left: allFontleft,
    fontSize: lang_lat_textvwFontSize,
    evented: true,
    staticfontSize:10,
    shadow: 'rgba(0, 0, 0, 0.8) 0px 0px 10px'
  });

  let city_textvwFontSize = mapcanvas.width * 0.050;
  var city_text = new fabric.Textbox("Text", {
    id: "cityText",
    selectable: false,
    fill: backgroundColor,
    fontStyle: 'normal',
    fontWeight: 600,
    width: allFontWidthVh,
    text: '',
    textAlign: 'center',
    autoCapitalize: "on",
    fontFamily: "Montserrat,sans-serif",
    // top: mapcanvas.height / 1.25,
    top: lang_lat_text.top + lang_lat_text.height + 5,
    left: allFontleft,
    fontSize: city_textvwFontSize,
    evented: true,
    staticfontSize:10,
    shadow: 'rgba(0, 0, 0, 0.5) 0px 0px 20px'
  });

  let country_textvwFontSize = mapcanvas.width * 0.028;
  var country_text = new fabric.Textbox("Text", {
    id: "countryText",
    selectable: false,
    fill: backgroundColor,
    fontStyle: 'italic',
    fontWeight: 300,
    width: allFontWidthVh,
    text: '',
    textAlign: 'center',
    fontFamily: "cursive",
    // top: mapcanvas.height / 1.18 + city_text.height,
    top: city_text.top + city_text.height + 5,
    left: allFontleft,
    fontSize: country_textvwFontSize,
    evented: true,
    staticfontSize:10,
    cornerSize: 0,
    hasBorders: false,
    shadow: 'rgba(0, 0, 0, 0.8) 0px 0px 10px'
  });






// ========================== add to cart ==========================


  function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  $(".customize_map_wrapper .step-item-wrapper button.product_buy_btn").click(function(e) {
    var img = new Image();
    var mapCanvas = document.querySelector('.mapboxgl-canvas'),
        mapbottlrCanvas = document.getElementById('map_product_canvas'),
        ImageURL = mapCanvas.toDataURL(),
        bottelImageURL = mapbottlrCanvas.toDataURL(), 
        block = ImageURL.split(";"),
        bottleblock = bottelImageURL.split(";"),
        contentType = block[0].split(":")[1],
        realData = block[1].split(",")[1],
        bottelcontentType = bottleblock[0].split(":")[1],
        bottelrealData = bottleblock[1].split(",")[1],
        blob = b64toBlob(realData, contentType),
        bottelblob = b64toBlob(bottelrealData, bottelcontentType),
        data = new FormData();
  
        data.append('sections', 'cart-drawer');
        data.append("id", $(this).data('variant-id'));
        data.append("quantity", Number($(".qty_input").val()));
        data.append("properties[long & lat]", $(".input_custom_field[data-field='input_field_1']").val());
        data.append("properties[Name]", $(".input_custom_field[data-field='input_field_2']").val());
        data.append("properties[Country]", $(".input_custom_field[data-field='input_field_3']").val());
        data.append("properties[Map]", blob);
        data.append("properties[Product Image]", bottelblob);
    
      $(this).attr("disabled","disabled");
      var $this = $(this);
      $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: data,
        contentType:false,
        processData:false,
        cache: false,
        success: function (item) {
          $this.removeAttr("disabled","disabled");
          document.dispatchEvent(
            new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
          );
          document.querySelector('.js-cart-drawer').open();
        },
        error: function (error) {
          $this.next(".error_message").html(`<p>${error.responseJSON.message}</p>`);
          $this.removeAttr("disabled","disabled");
          setTimeout(() => {
            $this.next(".error_message").html("");
          },5000)
        }
      });
  });